import styled from 'styled-components';
import { colors } from 'Constants/Colors';
import { display, maxWidth, minWidth, positions } from '@mui/system';

export const Title = styled.p`
  font-size: 1rem;
  font-weight: bold;
  min-height: 2rem;
`;

export const IconContaniner = styled.div`
  position: absolute;
  background: ${colors.GREEN_LEAF};
  display: flex;
  align-items: center;
  border-radius: 50%;
  padding: 0.2rem;
  z-index: 100;
  right: -1rem;
  top: -1rem;
  cursor: pointer;
`;

export const ChipContaniner = styled.div`
  position: absolute;
  display: inline-flex;
  justify-content: space-between;
  border-radius: 15px;
  z-index: 100;
  width: 100%;
  bottom: 1rem;
  padding-inline: 1rem;
`;

export const ContaninerRelative = styled.div`
  position: relative;
  width: 100%;
`;

export const EmptyImage = styled.div`
  position: relative;
  background: ${colors.GRAY};
  display: flex;
  justify-content: center;
`;

export const LoadingContainer = styled.div`
  background: ${colors.GRAY};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 22vh;
`;

export const IconProgres = {
  color: colors.GREEN,
};

export const IconStyle = {
  color: 'white',
  height: '180px',
  margin: 'auto',
};

export const ContainerStyle = {
  position: 'relative',
  width: 345,
  marginBottom: '1rem',
  marginTop: '1rem',
};

export default {
  Title,
  IconContaniner,
  ChipContaniner,
  ContaninerRelative,
  EmptyImage,
  IconProgres,
  IconStyle,
  ContainerStyle,
  LoadingContainer,
};
